import { MessageSquareDashed } from "lucide-react";

const EmptyState = ({
  hasFilter,
  onClear,
  titleActive = "Không có tin nhắn nào khớp",
  titleEmpty = "Chưa có tin nhắn nào",
  descActive = "Thử mở rộng khoảng thời gian hoặc bỏ bớt filter để xem thêm.",
  descEmpty = "Tin nhắn sẽ xuất hiện ở đây khi bot bắt đầu hoạt động.",
}) => (
  <div className="text-center py-16 px-4">
    <div className="w-16 h-16 mx-auto rounded-2xl bg-gray-100 flex items-center justify-center mb-4">
      <MessageSquareDashed size={28} className="text-gray-400" />
    </div>
    <h3 className="text-base font-semibold text-gray-900">
      {hasFilter ? titleActive : titleEmpty}
    </h3>
    <p className="text-sm text-gray-500 mt-1.5 max-w-sm mx-auto">
      {hasFilter ? descActive : descEmpty}
    </p>
    {hasFilter && (
      <button
        type="button"
        onClick={onClear}
        className="mt-4 inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-indigo-600 hover:text-indigo-700"
      >
        Xóa tất cả filter
      </button>
    )}
  </div>
);

export default EmptyState;
